import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import logoCobee from "../../assets/logo-cobee.svg";
import { useMetrics } from "../../metrics.ts";
import { ROUTES } from "../../routes";
import { Logout } from "../Logout";
import { Footer } from "../footer";
import { HomeIcon } from "../icons/HomeIcon";
import { LogoutIcon } from "../icons/LogoutIcon";
import { TransactionsIcon } from "../icons/TransactionsIcon";

const Layout = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { trackAction } = useMetrics();
  const handleNavigateToProfile = () => {
    trackAction.click({
      screenName: "Layout",
      componentName: "sidebar Profile button",
    });
    navigate(ROUTES.PROFILE);
  };
  const handleNavigateToTransactions = () => {
    trackAction.click({
      screenName: "Layout",
      componentName: "sidebar Transactions button",
    });
    navigate(ROUTES.TRANSACTIONS);
  };

  const getSelectedRouteBackground = (route: string) => {
    const itemSelected = pathname.includes(route);
    if (itemSelected) return "bg-secondary-main";

    return "bg-white";
  };

  const getSelectedRouteTextColor = (route: string) => {
    const itemSelected = pathname.includes(route);
    if (itemSelected) return "text-white";

    return "text-gray-700";
  };

  return (
    <div className="flex w-screen h-screen">
      <div className="flex flex-col items-start w-[200px] py-2 pt-16 pb-8 gap-y-96">
        <nav
          role="navigation"
          className="flex w-[174px] flex-col items-start gap-24 flex-1"
        >
          <ul className="flex p-0 flex-col items-start gap-2 self-stretch">
            <li className="flex flex-row" onClick={handleNavigateToProfile}>
              <div
                className={`w-5 h-10 rounded-xl ${getSelectedRouteBackground(
                  ROUTES.PROFILE
                )} -ml-[10px] mr-2`}
              />
              <div
                className={`flex w-[166px] p-2 items-center gap-2 cursor-pointer ${getSelectedRouteTextColor(
                  ROUTES.PROFILE
                )} ${getSelectedRouteBackground(ROUTES.PROFILE)} rounded-xl`}
              >
                <HomeIcon />
                <span
                  className={`text-sm font-medium ${getSelectedRouteTextColor(
                    ROUTES.PROFILE
                  )}`}
                >
                  {t("layout.profile")}
                </span>
              </div>
            </li>
            <li
              className="flex flex-row"
              onClick={handleNavigateToTransactions}
            >
              <div
                className={`w-5 h-10 rounded-xl ${getSelectedRouteBackground(
                  ROUTES.TRANSACTIONS
                )} -ml-[10px] mr-2`}
              />
              <div
                className={`flex w-[166px] p-2 items-center gap-2 cursor-pointer ${getSelectedRouteTextColor(
                  ROUTES.TRANSACTIONS
                )} ${getSelectedRouteBackground(
                  ROUTES.TRANSACTIONS
                )} rounded-xl`}
              >
                <TransactionsIcon />
                <span className="text-sm font-medium">
                  {t("layout.transactions")}
                </span>
              </div>
            </li>
          </ul>
        </nav>
        <nav
          className="flex flex-col items-center gap-24 self-stretch"
          role="navigation"
        >
          <ul className="flex flex-col items-center w-48 gap-2">
            <li className="flex flex-row text-gray-700 items-center">
              <LogoutIcon />
              <Logout />
            </li>
            <li className="m-4">
              <img src={logoCobee} alt={t("common.logo")} />
            </li>
          </ul>
        </nav>
      </div>
      <div className="flex flex-col w-full bg-gray-50">
        <main className="p-8 overflow-y-auto">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export { Layout };
